import { useMedia } from './useMedia';
import { withMedia } from './withMedia';

export { withMedia };

export default useMedia;
